import { fonts } from "./themeConfig"

export const h1Apercu = {
  fontFamily: fonts.apercu,
  fontSize: {
    base: "1.75rem",
    md: "2.625rem",
  },
  lineHeight: {
    base: "2.125rem",
    md: "3.25rem",
  },
  letterSpacing: "0",
  fontWeight: "400",
  marginTop: {
    base: "1.5rem",
    md: "2.5rem",
  },
  marginBottom: {
    base: "1rem",
  },
  css: {
    fontFeatureSettings: '"liga" 0',
  },
}

export const h2Apercu = {
  fontFamily: fonts.apercu,
  fontSize: {
    base: "1.5rem",
    md: "1.75rem",
  },
  lineHeight: {
    base: "2rem",
    md: "2.25rem",
  },
  letterSpacing: "0",
  fontWeight: "400",
  marginTop: {
    base: "1.5rem",
    md: "2.5rem",
  },
  marginBottom: {
    base: "1rem",
  },
  css: {
    fontFeatureSettings: '"liga" 0',
  },
}

export const h3Apercu = {
  fontFamily: fonts.apercu,
  fontSize: {
    base: "1.25rem",
    md: "1.5rem",
  },
  lineHeight: {
    base: "1.75rem",
    md: "2.125rem",
  },
  letterSpacing: "0",
  fontWeight: "400",
  marginTop: {
    base: "1.5rem",
    md: "2.5rem",
  },
  marginBottom: {
    base: "1rem",
  },
  css: {
    fontFeatureSettings: '"liga" 0',
  },
}

export const h4Apercu = {
  fontFamily: fonts.apercu,
  fontSize: {
    base: "1rem",
    md: "1.25rem",
  },
  lineHeight: {
    base: "1.5rem",
    md: "1.75rem",
  },
  letterSpacing: "0",
  fontWeight: "400",
  marginTop: {
    base: "1.5rem",
    md: "2.5rem",
  },
  marginBottom: {
    base: "0.75rem",
    md: "0.875rem",
  },
  css: {
    fontFeatureSettings: '"liga" 0',
  },
}

export const h5Apercu = {
  fontFamily: fonts.apercu,
  fontSize: "1rem",
  lineHeight: {
    base: "1.25rem",
    md: "1.5rem",
  },
  letterSpacing: "0",
  fontWeight: "400",
  marginTop: {
    base: "1.5rem",
    md: "2.5rem",
  },
  marginBottom: {
    base: "1rem",
  },
  css: {
    fontFeatureSettings: '"liga" 0',
  },
}
